/* CertificationBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _16 = "._zg8l4jg8{font-style:normal}";
const _15 = "._1dyzze3t{letter-spacing:var(--ds-space-0,0)}";
const _14 = "._k48p1nn1{font-weight:400}";
const _13 = "._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _12 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _11 = "._1wyboxwj{font-size:.875rem}";
const _10 = "._vwz4v47k{line-height:var(--ds-space-250,20px)}";
const _9 = "._1yt41jx4{padding:var(--_1trntrs)}";
const _8 = "._1wyboqnp{font-size:.75rem}";
const _7 = "._k48pni7l{font-weight:600}";
const _6 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Tooltip from '@atlaskit/tooltip';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { RunsOnAtlassianIcon } from '@atlassian/mpac-primitives';
import { CloudFortifiedAppIcon, CloudSecurityParticipantIcon } from '@atlassian/mpac-ui';
import { TEST_IDS } from '../../primitives/testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._vwz4kb7n{line-height:1}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._zulpv77o{gap:var(--ds-space-025,2px)}";
const _ = "._1yt4iaxp{padding:var(--ds-space-050,4px) var(--ds-space-0,0)}";
const CertificationBadgeContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4iaxp _zulpv77o _1e0c1txw _4cvr1h6o _vwz4kb7n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CertificationBadgeContainer.displayName = 'CertificationBadgeContainer';
}
const Text = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _k48pni7l _1wyboqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
const CertificationBadgeContainerStyle = null;
const badge = {
  CLOUD_FORTIFIED: {
    icon: /*#__PURE__*/_jsx(CloudFortifiedAppIcon, {
      label: "Cloud Fortified App Badge",
      size: "small"
    }),
    text: 'CLOUD FORTIFIED',
    tooltip: 'Apps that meet all cloud security and reliability requirements'
  },
  CLOUD_SECURITY_PARTICIPANT: {
    icon: /*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
      label: "Cloud Security Participant App Badge",
      primaryColor: "var(--ds-icon-brand, #0C66E4)",
      size: "small"
    }),
    text: 'CLOUD SECURITY PARTICIPANT',
    tooltip: 'App is enrolled in the Marketplace Bug Bounty Program'
  },
  RUNS_ON_ATLASSIAN: {
    icon: /*#__PURE__*/_jsx(RunsOnAtlassianIcon, {
      label: "Runs on Atlassian Badge",
      size: "small"
    }),
    text: 'RUNS ON ATLASSIAN',
    tooltip: 'Apps that run on the same infrastructure as Atlassian products'
  }
};
const updateRunsOnAtlassianTooltip = enableAppificationChanges => {
  return enableAppificationChanges ? 'Marketplace apps that run on the same infrastructure as Atlassian apps' : 'Apps that run on the same infrastructure as Atlassian products';
};
export const CertificationBadge = props => {
  const {
    icon,
    text,
    tooltip
  } = badge[props.certification];
  const {
    enableMpacWebCoherence,
    enableAppificationChanges
  } = useStatsig();
  const updatedTooltip = props.certification === 'RUNS_ON_ATLASSIAN' ? updateRunsOnAtlassianTooltip(enableAppificationChanges()) : tooltip;
  return /*#__PURE__*/_jsx(Tooltip, {
    content: updatedTooltip,
    position: "bottom-start",
    children: enableMpacWebCoherence() ? /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_9, _2, _3, _4, _10, _11, _12, _13, _14, _15, _16]
      }), /*#__PURE__*/_jsxs("div", {
        "data-testid": TEST_IDS.CERTIFICATION_BADGE,
        className: ax(["_1yt41jx4 _zulpv77o _1e0c1txw _4cvr1h6o _vwz4v47k _1wyboxwj _syaz1fxt _ect41gqc _k48p1nn1 _1dyzze3t _zg8l4jg8"]),
        style: {
          "--_1trntrs": ix("var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-0, 0px)"))
        },
        children: [icon, text]
      })]
    }) : /*#__PURE__*/_jsxs(CertificationBadgeContainer, {
      "data-testid": TEST_IDS.CERTIFICATION_BADGE,
      children: [icon, /*#__PURE__*/_jsx(Text, {
        children: text
      })]
    })
  });
};